import { render, staticRenderFns } from "./CausewayPass.vue?vue&type=template&id=08bbc75f&scoped=true&"
import script from "./CausewayPass.vue?vue&type=script&lang=js&"
export * from "./CausewayPass.vue?vue&type=script&lang=js&"
import style0 from "./CausewayPass.vue?vue&type=style&index=0&id=08bbc75f&prod&lang=css&"
import style1 from "./CausewayPass.vue?vue&type=style&index=1&id=08bbc75f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbc75f",
  null
  
)

export default component.exports